// extracted by css-extract-rspack-plugin
export default {"card":"aeIbVlxf","disabled":"Eyg23dJ_","container":"J4U89Oq4","header":"WA7Rx3pH","footer":"Z7DZLSwl","panView":"EaJ6_vkZ","accountView":"GmumYriH"};